module.exports = __webpack_public_path__ + "media/images/front/icon_movie_free-1d0e85ee47cb31cc5af17c20aa6f5c2c.png";